"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = exports.RadioButtonVariant = void 0;
const react_1 = __importDefault(require("react"));
const useFormControl_1 = __importDefault(require("@material-ui/core/FormControl/useFormControl"));
const useRadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup/useRadioGroup"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const utils_1 = require("../../lib/utils");
const theme_1 = __importDefault(require("../../styles/theme"));
const styled_div_1 = __importDefault(require("../styled-div"));
/**
 *
 * Radio Button Usage Example:
 *
   <RadioGroupButton
    dataItems={['Item1', 'Item2', 'Item3', 'Item4']} --> Add list of all radio button options
    name="radio button name"
    title="Title to be displayed on top of the radio buttons"
    margin="m" --> not required
    padding="xs" --> not required
    border --> not required
    onChange=changeMethod()
  />
 *
 */
const useStyles = makeStyles_1.default({
    upliftRadio: {
        color: theme_1.default.colors.textInput,
        '&$checked': {
            color: theme_1.default.colors.primaryAccent,
        },
        '&.Mui-focusVisible': {
            outline: theme_1.default.outline,
            outlineOffset: '-8px',
        },
        '&&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checked: {},
});
var RadioButtonVariant;
(function (RadioButtonVariant) {
    RadioButtonVariant["default"] = "default";
    RadioButtonVariant["prominent"] = "prominent";
})(RadioButtonVariant = exports.RadioButtonVariant || (exports.RadioButtonVariant = {}));
/**
 * Renders a radio button.
 */
const RadioButton = ({ ariaLabel, checked, className, disabled = false, error = false, id, label, name, onChange = utils_1.noop, onBlur = utils_1.noop, onFocus = utils_1.noop, onClick = utils_1.noop, required, style, value, variant = RadioButtonVariant.default, }) => {
    const classes = useStyles();
    const formControlContext = useFormControl_1.default();
    const radioGroupContext = useRadioGroup_1.default();
    const isDisabled = disabled || (formControlContext === null || formControlContext === void 0 ? void 0 : formControlContext.disabled);
    const isError = error || (formControlContext === null || formControlContext === void 0 ? void 0 : formControlContext.error);
    const isSelected = radioGroupContext
        ? radioGroupContext.value === value
        : checked;
    const isProminent = variant === RadioButtonVariant.prominent;
    const margin = isProminent ? 's' : 'xxs';
    const paddingHort = isProminent ? 's' : 'none';
    const paddingVert = isProminent ? 'xs' : 'none';
    const background = isProminent && isSelected
        ? theme_1.default.colors.backgroundPrimaryAccent
        : undefined;
    let borderColor;
    if (isProminent) {
        borderColor = isSelected
            ? theme_1.default.colors.primaryAccent
            : theme_1.default.colors.borderDefault;
    }
    return (react_1.default.createElement(styled_div_1.default, { background: background, borderColor: borderColor, className: className, "data-testid": "radio-button-wrapper", marginTop: margin, paddingHorizontal: paddingHort, paddingVertical: paddingVert, style: style },
        react_1.default.createElement(FormControlLabel_1.default, { value: value, control: react_1.default.createElement(Radio_1.default, { classes: {
                    checked: classes.checked,
                    root: classes.upliftRadio,
                }, color: "primary", checked: checked, disabled: isDisabled, id: id, inputProps: {
                    'aria-label': ariaLabel,
                    'aria-required': required,
                }, name: name, onChange: (e) => onChange(e.target.value), onBlurCapture: onBlur, onFocusCapture: onFocus, onClick: onClick, required: required, style: {
                    color: isError ? theme_1.default.colors.error : undefined,
                } }), label: label })));
};
exports.RadioButton = RadioButton;
exports.default = exports.RadioButton;
